<template>
  <div class="form">
    <v-card style="margin-top: 250px">
          <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          <h1 align="center" style="text-decoration: underline overline">
            JRH - SEKSYEN 5 : KEBOLEHCAPAIAN MAKANAN
          </h1>

          <v-text-field
            outlined
            dense
            rounded
            v-model="HID"
            label="HID"
            :rules="rules"
            width="20px"
            disabled
          ></v-text-field>

          <!-- DATATABLE  -->
          <v-card color="rgba(217, 217, 217, 0.5)" class="mb-5">
            <v-card-title>
              Senarai
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="dataJRH"
              :search="search"
              class="ml-3 mr-3"
              @click:row="handleClick"
              :footer-props="{ 'items-per-page-options': [3, 15, 30, 50, 100, -1] }"
            ></v-data-table>
          </v-card>
        </v-card>

    <v-card>
      <span style="color:red;font-weight:bold;font-size: small;"> <v-col>Medan yang bertanda * wajib diisi </v-col></span>
      <v-card-title>
        <strong>SEKSYEN 5 : KEBOLEHCAPAIAN MAKANAN </strong><br />
      </v-card-title>
      <br />
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <!-- S183 -->
          <v-row>
            <!-- * Sekiranya S2 adalah Ketua isi rumah -->
            <v-col class="black--text">
              S.1  Berapakah jarak dan anggaran masa perjalanan dari tempat
              kediaman ke premis perniagaan yang terdekat?<br /><br />
            </v-col>
          </v-row>
          <v-container>
            <v-col>
              <v-row>
                <v-row>
                  <strong>i. Kedai Runcit </strong>
                </v-row>
              </v-row>
            </v-col>
            <v-row>
             <v-col cols="4" sm="6" md="4" class="black--text">
                Jarak <strong>[KRTJ]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                <v-autocomplete
                  :items="Jarak"
                 :item-text="item => item.id + ' - ' + item.desc"
                  item-value="id"
                  label=""
                  return-object
                  solo
                  dense
                  style="width:350px;"
                  v-model="KRTJ"
                  min="1"
                  max="3"
                ></v-autocomplete>
              </v-col>

              <v-col cols="4" sm="6" md="4" class="black--text">
                Masa <strong>[KRTM]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                <v-autocomplete
                  :items="Masa"
                 :item-text="item => item.id + ' - ' + item.desc"
                  item-value="id"
                  label=""
                  return-object
                  solo
                  dense
                  style="width:350px;"
                  v-model="KRTM"
                  min="1"
                  max="3"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-col>
              <v-row>
                <v-row mt="2">
                  <strong>ii. Pasar Raya </strong>
                </v-row>
              </v-row>
            </v-col>
            <v-row>
              <v-col cols="4" sm="6" md="4" class="black--text">
                Jarak <strong>[PSRJ]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                <v-autocomplete
                  :items="Jarak"
                  :item-text="item => item.id + ' - ' + item.desc"
                  item-value="id"
                  label=""
                  return-object
                  solo
                  dense
                  style="width:350px;"
                  v-model="PSRJ"
                  min="1"
                  max="3"
                ></v-autocomplete>
              </v-col>

              <v-col cols="4" sm="6" md="4" class="black--text">
                Masa <strong>[PSRM]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
               <v-autocomplete
                  :items="Masa"
                  :item-text="item => item.id + ' - ' + item.desc"
                  item-value="id"
                  label=""
                  return-object
                  solo
                  dense
                  style="width:350px;"
                  v-model="PSRM"
                  min="1"
                  max="3"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-col>
              <v-row>
                <v-row mt="2">
                  <strong>iii. Pasar Tani </strong>
                </v-row>
              </v-row>
            </v-col>
            <v-row>
              <v-col cols="4" sm="6" md="4" class="black--text">
                Jarak <strong>[PSTJ]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                <v-autocomplete
                  :items="Jarak"
                  :item-text="item => item.id + ' - ' + item.desc"
                  item-value="id"
                  label=""
                  return-object
                  solo
                  dense
                  style="width:350px;"
                  v-model="PSTJ"
                  min="1"
                  max="3"
                ></v-autocomplete>
              </v-col>

             <v-col cols="4" sm="6" md="4" class="black--text">
                Masa <strong>[PTSM]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                <v-autocomplete
                  :items="Masa"
                  :item-text="item => item.id + ' - ' + item.desc"
                  item-value="id"
                  label=""
                  return-object
                  solo
                  dense
                  style="width:350px;"
                  v-model="PSTM"
                  min="1"
                  max="3"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>

          <br />
          <v-row>
            <!-- * Sekiranya S2 adalah Ketua isi rumah -->
            <v-col  class="black--text">
              S.2  Adakah terdapat perkhidmatan jualan bergerak di kawasan anda? <br />
            </v-col>
          </v-row>
          
            <v-row>
              <v-col cols="4" sm="6" md="4" class="black--text">
                i. Bahan makanan mentah <strong>[JMM]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                <v-autocomplete
                  :items="yaTidak"
                  :item-text="item => item.id + ' - ' + item.desc"
                  item-value="id"
                  label=""
                  return-object
                  solo
                  dense
                  style="width:350px;"
                  v-model="JMM"
                  min="1"
                  max="3"
                ></v-autocomplete>
              </v-col>

             <v-col cols="4" sm="6" md="4" class="black--text">
                ii. Bahan makanan bermasak <strong>[JMB]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                <v-autocomplete
                  :items="yaTidak"
                  :item-text="item => item.id + ' - ' + item.desc"
                  item-value="id"
                  label=""
                  return-object
                  solo
                  dense
                  style="width:350px;"
                  v-model="JMB"
                  min="1"
                  max="3"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <br/>

            <v-row>
              <!-- * v-show="showsS185"  Sekiranya S2 adalah Ketua isi rumah -->
              <v-col class="black--text">
                S.3 Adakah terdapat perkhidmatan penghantaran bergerak di kawasan anda? <br />
              </v-col>
            </v-row>
          
             <v-row>
                <v-col cols="4" sm="6" md="4" class="black--text">
                  i. Bahan makanan mentah <strong>[PMM]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                  <v-autocomplete
                    :items="yaTidak"
                    :item-text="item => item.id + ' - ' + item.desc"
                    item-value="id"
                    label=""
                    return-object
                    solo
                    dense
                    style="width:350px;"
                    v-model="PMM"
                    min="1"
                    max="3"
                  ></v-autocomplete>
              </v-col>

              <v-col cols="4" sm="6" md="4" class="black--text">
                ii. Bahan makanan bermasak <strong>[PMB]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                 <v-autocomplete
                  :items="yaTidak"
                  :item-text="item => item.id + ' - ' + item.desc"
                  item-value="id"
                  label=""
                  return-object
                  solo
                  dense
                  style="width:350px;"
                  v-model="PMB"
                  min="1"
                  max="3"
                 ></v-autocomplete>
                </v-col>
              </v-row>
            

            
           
                <!-- <v-col cols="4" sm="6" md="7" class="black--text">
                  S184. Adakah perkhidmatan jualan bahan makanan mentah/ bermasak
                  bergerak terdapat di kawasan anda? <strong>[MB]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span><br />
                <v-autocomplete
                    :items="yaTidak"
                  :item-text="item => item.id + ' - ' + item.desc"
                    item-value="id"
                    label=""
                    return-object
                    solo
                    dense
                    style="width: 350px"
                    v-model="MB"
                    min="1"
                    max="2"
                    @change="onChangeS184"
                ></v-autocomplete>
                </v-col> v-show="showsS186"   -->
            <v-row>
                <v-col cols="4" sm="6" md="7" class="black--text">
                  S.4  Berapakah masa/tempoh perkhidmatan pasar malam/ pasar tani/
                  pasar pagi beroperasi di kawasan anda? <strong>[KPP]</strong><br />
                  <v-autocomplete
                    :items="pasarKekerapan"
                    :item-text="item => item.id + ' - ' + item.desc"
                    item-value="id"
                    label=""
                    return-object
                    solo
                    dense
                    style="width: 350px"
                    v-model="KPP"
                  ></v-autocomplete>
                  </v-col>

                  <!-- * Sekiranya jawapan di S185 dipilih -->
                  <v-col cols="4" sm="6" md="7" class="black--text">
                  S.5  Adakah anda mempunyai kemudahan peralatan komunikasi untuk
                  membuat pesanan bahan makanan? <strong>[PMP]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span><br />
                  <v-autocomplete
                    :items="yaTidak"
                    :item-text="item => item.id + ' - ' + item.desc"
                    item-value="id"
                    label=""
                    return-object
                    solo
                    dense
                    style="width: 350px"
                    v-model="PMP"
                   
                  ></v-autocomplete>
                  </v-col>
            </v-row>

            <v-row>
              <v-col cols="4" sm="6" md="7" class="black--text">
                S.6  Secara kebiasaannya, berapa lama bekalan makanan boleh bertahan sebelum pembelian seterusnya? <strong>[BBM]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                <v-autocomplete
                  :items="bekalan"
                  :item-text="item => item.id + ' - ' + item.desc"
                  item-value="id"
                  label=""
                  return-object
                  solo
                  dense
                  style="width:350px;"
                  v-model="BBM"
                  min="1"
                  max="5"
                ></v-autocomplete>
              </v-col>
            </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click='simpan()' 
        v-show="butangSimpan" 
        :disabled="!KRTJ || !KRTM || !PSRJ || !PSRM || !PSTJ|| !PSTM || !JMM || !JMB || !PMM || !PMB || !KPP || !PMP || !BBM">
        Simpan
        </v-btn>
        <v-btn
          text
          color="primary"
          v-show="butangKemaskini"
          @click="updateJRH()"
        >
          Kemaskini
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-alert prominent type="error" :value="popUpALert">
      <v-row align="center" class="mb-2">
        <v-col class="grow"> Adakah anda pasti untuk padam? </v-col>
        <v-col class="shrink">
          <v-btn @click="padam('1')" class="mb-3">Confirm</v-btn>
          <v-btn @click="padam('2')">Cancel</v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <!-- Error Dialog -->
    <v-dialog v-model="errorDialog" width="500" height="200">
      <v-card>
        <v-alert dense outlined color="#C51162" type="error">
          <strong>{{ errMessage }}</strong>
        </v-alert>
      </v-card>
    </v-dialog>

    <!-- Success Dialog -->
    <v-dialog v-model="successDialog" width="500" height="200">
      <v-card color="success">
        <v-alert dense outlined color="#C51162" type="success">
          <strong>{{ successMessage }}</strong>
        </v-alert>
      
         <v-card-actions> 
        <v-spacer></v-spacer>
            <v-btn
                color="warning"
                @click='successDialog = false;'
            >
              Batal
            </v-btn>
            <v-btn
                color="pink"
                v-show="butangKemaskini"
                @click='successDialog = false;'
            >
              Kemaskini
            </v-btn>
            <v-btn
              color="primary"
              @click='goTo("3")'
            >
              Pengisian Seterusnya
            </v-btn>
      </v-card-actions>
    </v-card>
</v-dialog>
  </div>
</template>
<script>
import axios from "axios";

//////////////////////////import services///////////////////
import getLocalStorage from "@/services/getLocalStorage";
const localStorageData = new getLocalStorage();

import hidServices from "@/services/lookupField";
const lookup = new hidServices();

import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();
//////////////////////////end import services//////////////

export default {
  async beforeMount() {
    var dataHID = localStorageData.getHIDdata();

    this.HID = dataHID.HID;
    this.BNO = dataHID.BNO;
    this.Ps = dataHID.P;
    this.S = dataHID.S;
    this.NG = dataHID.NG;
    this.DP = dataHID.DP;
    this.DB = dataHID.DB;
    this.BP = dataHID.BP;
    this.ST = dataHID.ST;
    this.NOTK = dataHID.NOTK;
    this.NOIR = dataHID.NOIR;
    this.Bulan = dataHID.BULAN;
    this.Tahun = dataHID.TAHUN;

    this.yaTidak = lookupFieldServices.getYaTidak();
    this.Jarak = lookupFieldServices.getJarak();
    this.Masa = lookupFieldServices.getMasa();
    this.pasarKekerapan = lookupFieldServices.getPasarKekerapan();
    this.currNOAIRData = localStorageData.getCurrentNOAIRData(); //dapatkan NOAIR yang di click dari page depan
    this.NOAIR = this.currNOAIRData.NOAIR;
    this.bekalan = lookupFieldServices.getBBM();
    this.getData(); //dapatkan data based on HID
    this.getDataPR24();
    this.getDataPR25();
    this.getDataPR26();

    console.log(this.bekalan)
  },

  data: () => ({
    updateButton: true,
    saveButton: false,
    dialog: false,
    butangSimpan: true,
    butangSebelumnya: false,
    butangKemaskini: false,
    successDialog: false,
    errorDialog: false,
    successMessage: '',
    errMessage: '',
    message: "Saving Data",
    popUpALert: false,
    search: '',
    currNOAIRData:'',
    yaTidak: [],
    Jarak: [],
    Masa: [],
    pasarKekerapan: [],
    bekalan: [],
    showS185: false,
    /////////////////////data declaration//////////////////////////

    HID: '',
    // NOAIR: '',
    KRTJ: '',
    KRTM: '',
    PSTJ: '',
    PSTM: '',
    PSRJ: '',
    PSRM: '',
    JMM: '',
    JMB: '',
    PMM: '',
    PMB: '',
    //MB: '',
    KPP: '',
    PMP: '',
    BBM: '',
  
    dataJRH: [],

    

    headers: [
      {
        align: "start",
        sortable: false,
      },

      { text: "HID", value: "HID" },
      { text: "KRTJ", value: "KRTJ" },
      { text: "KRTM", value: "KRTM" },
      { text: "PSRJ", value: "PSRJ" },
      { text: "PSRM", value: "PSRM" },
      { text: "PSTJ", value: "PSTJ" },
      { text: "PSTM", value: "PSTM" },
      { text: "JMM", value: "JMM" },
      { text: "JMB", value: "JMB" },
      { text: "PMM", value: "PMM" },
      { text: "PMB", value: "PMB" },
      //{ text: "MB", value: "MB" },
      { text: "KPP", value: "KPP" },
      { text: "PMP", value: "PMP" },
      { text: "BBM", value: "BBM" },
    ],
    ///////////link untuk ke page/////////////////////
    breadcrumbs: [
        {
          text: 'Status Pengisian',
          disabled: false,
          href: 'ringkasanMaklumatIR',
        },
      // {
      //   text: "JR2",
      //   disabled: true,
      //   href: "JR2",
      // },
      // {
      //   text: "JR4 - JRC",
      //   disabled: true,
      //   href: "JRC",
      // },
      // {
      //   text: "JR4 - JRB",
      //   disabled: true,
      //   href: "JRB",
      // },
      // {
      //   text: "HK1",
      //   disabled: false,
      //   href: "HK1",
      // },
      // {
      //   text: "JRE1",
      //   disabled: false,
      //   href: "JRE1",
      // },
      // {
      //   text: "JRE2",
      //   disabled: true,
      //   href: "JRE2",
      // },
      // {
      //   text: "JRF",
      //   disabled: true,
      //   href: "JRF",
      // },
      // {
      //   text: "JRG",
      //   disabled: false,
      //   href: "JRG",
      // },
      {
        text: "JRH",
        disabled: true,
        href: "JRH",
      },
      // {
      //   text: "PERBELANJAAN",
      //   disabled: false,
      //   href: "PERBELANJAAN",
      // },
    ],
    valid: true,
    name: "",
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    rules: {
      required: (v) => !!v || "field is required",
      emel: (value) => {
        return /.+@.+\..+/.test(value) || "E-mail must be valid";
      },
      percentage: (value) => {
        return value <= 100 || "Percentage must between 1 - 100";
      },
      takmauPoint: (value) => {
        return value % 1 === 0 ? true : "No point needed";
      },
    },
    select: null,
    items: ["Item 1", "Item 2", "Item 3", "Item 4"],
    checkbox: false,
  }),

  methods: {
    getUnits: function (a) {
      alert(`${a}`);
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    async simpan() {
      
      if (this.$refs.form.validate()) {
        this.dialog = true;
        setTimeout(() => (this.dialog = false), 2000);
        try {
          const res = await axios.post(
            `${process.env.VUE_APP_API_URL}/JR5/JRH`,
            {
              HID: this.HID,
              KRTJ: this.KRTJ.id,
              KRTM: this.KRTM.id,
              PSRJ: this.PSRJ.id,
              PSRM: this.PSRM.id,
              PSTJ: this.PSTJ.id,
              PSTM: this.PSTM.id,
              //MB: this.MB.id,
              JMM: this.JMM.id,
              JMB: this.JMB.id,
              PMM: this.PMM.id,
              PMB: this.PMB.id,
              KPP: this.KPP.id,
              PMP: this.PMP.id,
              BBM: this.BBM.id,
            }
          );
          this.res = res.data;
          this.successDialog = true;
          // setTimeout(() => (this.successDialog = false), 2000);
          this.successMessage = "Data Disimpan!";
          this.reset();
          this.getData();
          // setTimeout(() => this.goTo(), 1000);
        } catch (error) {
          //console.log(error)
          this.errorDialog = true;
          setTimeout(() => (this.errorDialog = false), 2000);
          this.errMessage = "Simpan : " + error;
        }
      } else {
        window.scrollTo(0, 0);
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "Please fill in the field!";
      }
    },
    async updateJRH() {
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/JR5/updateJRH`,
          {
            HID: this.HID,
            KRTJ: this.KRTJ.id,
            KRTM: this.KRTM.id,
            PSRJ: this.PSRJ.id,
            PSRM: this.PSRM.id,
            PSTJ: this.PSTJ.id,
            PSTM: this.PSTM.id,
            //MB: this.MB.id,
            JMM: this.JMM.id,
            JMB: this.JMB.id,
            PMM: this.PMM.id,
            PMB: this.PMB.id,
            KPP: this.KPP.id,
            PMP: this.PMP.id,
            BBM: this.BBM.id,
          }
        );
       this.res = res.data;
        this.reset();
        this.butangKemaskini = false;
        this.successDialog = true;
        // setTimeout(() => (this.successDialog = false), 2000);
        this.successMessage = "Data Berjaya Dikemaskini!";
        this.getData();
        window.scrollTo(0, 0);
        //setTimeout(() => (this.goTo()), 1000);
      } catch (error) {
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "Simpan : " + error;
      }
    },
    async padam(val) {
      if (val == 0) {
        this.popUpALert = true;
      } else if (val == 1) {
        try {
          ///////////tunjukkan alert padam////////////
          this.popUpALert = false;
          ////send delete to API///////
          if (this.$refs.form.validate()) {
            const res = await axios.post(
              `${process.env.VUE_APP_API_URL}/JRH/JRH/delete`,
              {
                HID: this.HID,
              }
            );
            this.res = res.data;
            this.successDialog = true;
            setTimeout(() => (this.successDialog = false), 2000);
            this.successMessage = "Data Deleted!";
            this.saveButton = false;
            this.updateButton = true;
            this.reset();
            this.getData();
          } else {
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = "Please Fill In the field";
          }
        } catch (error) {
          //console.log(error)
          this.errorDialog = true;
          setTimeout(() => (this.errorDialog = false), 2000);
          this.errMessage = "Padam : " + error;
        }
      } else if (val == 2) {
        this.popUpALert = false;
      }
    },

    async getDataPR24(){
      
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/JR5/getDataPR24?HID=` +this.HID+`&NOAIR=`+this.NOAIR,{}
        );
            var dataz = res.data.data
            // this.PMP = Number(dataz[0].PR24);
        
            if (dataz[0].PR24 == 0 ) {
              this.PMP = { id: 2 };
            }
            else if (dataz[0].PR24 >= 1 ) {
              this.PMP = { id: 1 };
  
            }
          
          } catch (error) {
            console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 4000);
              this.errMessage = "Sila jawab soalan S24 di JRG terlebih dahulu!"
            }
      },

      async getDataPR25(){
      
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/JR5/getDataPR25?HID=` +this.HID+`&NOAIR=`+this.NOAIR,{}
        );
            var dataz = res.data.data
            // this.PMP = Number(dataz[0].PR25);
        
            if (dataz[0].PR25 == 0 ) {
              this.PMP = { id: 2 };
            }
            else if (dataz[0].PR25 >= 1 ) {
              this.PMP = { id: 1 };
  
            }
          
          } catch (error) {
            console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 4000);
              this.errMessage = "Sila jawab soalan S25 di JRG terlebih dahulu!"
            }
      },

      async getDataPR26(){
      
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/JR5/getDataPR26?HID=` +this.HID+`&NOAIR=`+this.NOAIR,{}
        );
            var dataz = res.data.data
            // this.PMP = Number(dataz[0].PR26);
        
            if (dataz[0].PR26 == 0 ) {
              this.PMP = { id: 2 };
            }
            else if (dataz[0].PR26 >= 1 ) {
              this.PMP = { id: 1 };
  
            }
          
          } catch (error) {
            console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 4000);
              this.errMessage = "Sila jawab soalan S26 di JRG terlebih dahulu!"
            }
      },

    async getData() {
      //dapatkan data dari table JRH based on HID
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/JR5/JRH?HID=` +
          this.HID +
              `&NOAIR=` +
              this.NOAIR,
          {}
        );
        var dataz = res.data.data;
        this.dataJRH = dataz;
      } catch (error) {
        //console.log(error)
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "getData : " + error;
      }
    },

    handleClick(row) {
      this.successDialog = true;
      this.successMessage = "Sila mulakan pengemaskinian!";
      // setTimeout(() => (this.successDialog = false), 1000);

      this.butangSimpan = false;
      this.butangKemaskini = true;

      this.HID = row.HID;
      // this.KRTJ = row.KRTJ;
      // this.KRTM = row.KRTM;
      // this.PSRJ = row.PSRJ;
      // this.PSRM = row.PSRM;
      // this.PSTJ = row.PSTJ;
      // this.PSTM = row.PSTM;
      // this.MB = row.MB;
      // this.KPP = row.KPP;
      // this.PMP = row.PMP;

      // or just do something with your current clicked row item data
      // console.log(row);

      // --------------------------------------------------------------
          if(row.KRTJ == 1){
            this.KRTJ = this.Jarak[0];
          }
          if(row.KRTJ == 2){
            this.KRTJ = this.Jarak[1];
          }
          if(row.KRTJ == 3){
            this.KRTJ = this.Jarak[2];
          }
          if(row.KRTM == 1){
            this.KRTM = this.Masa[0];
          }
          if(row.KRTM == 2){
            this.KRTM = this.Masa[1];
          }
          if(row.KRTM == 3){
            this.KRTM = this.Masa[2];
          }
      // ----------------------------------------------------------------
          if(row.PSRJ == 1){
            this.PSRJ = this.Jarak[0];
          }
          if(row.PSRJ == 2){
            this.PSRJ = this.Jarak[1];
          }
          if(row.PSRJ == 3){
            this.PSRJ = this.Jarak[2];
          }
          if(row.PSRM == 1){
            this.PSRM = this.Masa[0];
          }
          if(row.PSRM == 2){
            this.PSRM = this.Masa[1];
          }
          if(row.PSRM == 3){
            this.PSRM = this.Masa[2];
          }
      // ----------------------------------------------------------------
          if(row.PSTJ == 1){
            this.PSTJ = this.Jarak[0];
          }
          if(row.PSTJ == 2){
            this.PSTJ = this.Jarak[1];
          }
          if(row.PSTJ == 3){
            this.PSTJ = this.Jarak[2];
          }
          if(row.PSTM == 1){
            this.PSTM = this.Masa[0];
          }
          if(row.PSTM == 2){
            this.PSTM = this.Masa[1];
          }
          if(row.PSTM == 3){
            this.PSTM = this.Masa[2];
          }
      // ----------------------------------------------------------------
        // if(row.MB == 1){
        //     this.MB = this.yaTidak[0];
        //   }
        //   if(row.MB == 2){
        //     this.MB = this.yaTidak[1];
        //   }
        // ----------------------------------------------------------------
        if(row.JMM == 1){
            this.JMM = this.yaTidak[0];
          }
          if(row.JMM == 2){
            this.JMM = this.yaTidak[1];
          }
        // ----------------------------------------------------------------
        if(row.JMB == 1){
            this.JMB = this.yaTidak[0];
          }
          if(row.JMB == 2){
            this.JMB = this.yaTidak[1];
          }
        // ----------------------------------------------------------------
        if(row.PMM == 1){
            this.PMM = this.yaTidak[0];
          }
          if(row.PMM == 2){
            this.PMM = this.yaTidak[1];
          }
        // ----------------------------------------------------------------
        if(row.PMB == 1){
            this.PMB = this.yaTidak[0];
          }
          if(row.PMB == 2){
            this.PMB = this.yaTidak[1];
          }
        //---------------------------------------------------------------
         if(row.KPP == 1){
            this.KPP = this.pasarKekerapan[0];
          }
          if(row.KPP == 2){
            this.KPP = this.pasarKekerapan[1];
          }
           if(row.KPP == 3){
            this.KPP = this.pasarKekerapan[2];
          }
          if(row.KPP == 4){
            this.KPP = this.pasarKekerapan[3];
          }
        //---------------------------------------------------------------
         if(row.PMP == 1){
            this.PMP = this.yaTidak[0];
          }
          if(row.PMP == 2){
            this.PMP = this.yaTidak[1];
          }
        //---------------------------------------------------------------
          if(row.BBM == 1){
            this.BBM = this.bekalan[0];
          }
          if(row.BBM == 2){
            this.BBM = this.bekalan[1];
          }
           if(row.BBM == 3){
            this.BBM = this.bekalan[2];
          }
          if(row.BBM == 4){
            this.BBM = this.bekalan[3];
          }
          if(row.BBM == 5){
            this.BBM = this.bekalan[4];
        }

            //---------------------------------------------------------------
    },
    goTo(option) {
         if(option == "1"){
        this.$router.push({name: "JRH"});
      } 
      if(option == "2"){
        this.$router.push({ name: "ringkasanMaklumatIR" });    
      }

      if(option == "3"){
        this.$router.push({ name: "foodwaste" });    
      }
    },
    onChangeS184(val) {
      var valueS184 = val.id;
      if (valueS184 == 1) {
        this.showS185 = true;
      }
      if (valueS184 == 2) {
        this.showS185 = false;
      }
    },
  },
  watch: {
    MB(val) {
      if (val.id == 1) {
        //do nothing
      } else {
        this.KPP = { id: 0 };
        // this.PMP = { id: 0 };
      }
    },
    // JMM(val){
    //   if(val.id == 2 && this.JMB.id == 2){
    //     this.showsS185 = false;
    //     this.showsS186 = false;
    //     this.PMM = {id:0};
    //     this.PMB = {id:0};
    //     this.KPP = {id:0};
    //   }
    //   else{
    //     this.showsS185 = true;
    //     this.showsS186 = true;
    //   }
    // },
    // JMB(val){
    //   if(val.id == 2 && this.JMM.id == 2){
    //     this.showsS185 = false;
    //     this.showsS186 = false;
    //     this.PMM = {id:0};
    //     this.PMB = {id:0};
    //     this.KPP = {id:0};
        
    //   }
    //   else{
    //     this.showsS185 = true;
    //     this.showsS186 = true;
    //   }
    // },

  }
};
</script>

<style>
#app {
  background: url("~@/assets/HIES.jpg") no-repeat center center fixed !important;
  background-size: cover;
}
</style>